import { TabContext, TabList } from '@mui/lab';
import { styled, Tab } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
const TabListWrapper = styled(TabList)(({ theme }) => ({
    [theme.breakpoints.down(727)]: {
        order: 3,
    },
}));

const HeadingArea = ({ value, changeTab, header }) => {

    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center">
                <H5>Submitted Abstract</H5>
            </FlexBox>

            <TabContext value={value}>
                <TabListWrapper variant="scrollable" onChange={changeTab}>
                    <Tab
                        disableRipple
                        label={`All (${
                            header?.reduce(
                                (acc, cur) => acc + cur.total,
                                0,
                            ) || 0
                        })`}
                        value="all"
                    />

                    {header &&
                        header.map((item, index) => (
                            <Tab
                                key={index}
                                disableRipple
                                label={`${item.name} (${item.total})`}
                                value={item.id}
                            />
                        ))}
                </TabListWrapper>
            </TabContext>
        </Wrapper>
    );
};

export default HeadingArea;
